import $ from 'jquery';
import 'bootstrap';
import enableAtmosphericSciencesFunctionality from './atmospheric-sciences';
import enableFlightOperationsFunctionality from './flight-operations';
import enableGormanFieldFunctionality from './gorman-field';
import enableHomeFunctionality from './home';
import enableIssacFunctionality from './issac';
import enableIssacSecondaryFunctionality from './issac-secondary';
// wait until the DOM loads
$(() => {
    // enable specific page functionality
    enableAtmosphericSciencesFunctionality();
    enableFlightOperationsFunctionality();
    enableGormanFieldFunctionality();
    enableHomeFunctionality();
    enableIssacFunctionality();
    enableIssacSecondaryFunctionality();
});
